module.exports = __webpack_public_path__ + "img/burgerBuilder3.653c69be.png";